import { ref, readonly } from 'vue';
import type { Router } from 'vue-router';

/**
 * A function that will be used to resolve the router instance.
 */
let routerResolve: (router: Router) => void;

/**
 * A ref to track if the router is ready.
 */
const routerReady = ref(false);

/** Promise that resolves once router is initialized. */
const routerInstance = new Promise<Router>((resolve) => {
  routerResolve = resolve;
});

const setRouterReady = () => (routerReady.value = true);

const isRouterReady = readonly(routerReady);

const resolveRouterInstance = (router: Router) => {
  routerResolve(router);
  setRouterReady();
};

/**
 * UseDynamicRouter composable.
 * Provides access to the router instance, a flag indicating if the router is ready,
 * and a method to resolve the router instance.
 * @returns An object containing the router instance promise, a readiness flag,
 *          and a method to resolve the router instance.
 */
export const useDynamicRouter = () => {
  return {
    routerInstance,
    isRouterReady,
    resolveRouterInstance,
  };
};
